import React from 'react'

import { CheckedIconProps } from '../interfaces'

export const CheckedIcon = ({ className }: CheckedIconProps) => {
  return (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M1 5.00062L4.0001 8.00072L11.0009 1" stroke="none" strokeWidth="2" />
    </svg>
  )
}
